const state = {

    back: null,

    growler: {},

    isLoading: false,

    showFooter: true,

}

const getters = {

    back: state => state.back,

    growler: state => state.growler,

    isLoading: state => state.isLoading,

    showFooter: state => state.showFooter

}

const actions = {

  hideFooter({ commit })
  {
    commit('showFooter', false)
  },

  showFooter({ commit })
  {
    commit('showFooter', true)
  }

}

const mutations = {

    growl (state, data) {
      /**
       * @todo import from config .js
       */
      const defaults = {
        color: 'grey',
        status: true,
        content: ''
      }

      if( typeof data == 'string' )
        data = { content: data }
      
      state.growler = { 
        ...defaults,
        ...data 
      }

    },

    setBack (state, route = null) {
      state.back = route
    },

    setLoading (state, status = true) {
      state.isLoading = status
    },

    showFooter(state, status = true) {
      state.showFooter = status
    }

}

const ui = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default ui